import { BaseModel } from '../common/base-model/base-model';
import { AttendantServiceGroups } from '../attendant-service-groups/attendant-service-groups';
import { AttendantServices } from '../attendant-services/attendant-services';

export class Attendants extends BaseModel {
  constructor(
    public override id?: string,
    public name?: string,
    public user_central_id?: string,
    public attendants_service_groups?: AttendantServiceGroups[],
    public attendants_services?: AttendantServices[],
    public owner_root_entity_id?: string,
    public target_entity_id?: string,
  ) {
    super();
  }

  static fromJson(jsonData: any): Attendants {
    const attendants = Object.assign(new Attendants(), jsonData);
    if (
      jsonData.attendants_service_groups &&
      Array.isArray(jsonData.attendants_service_groups)
    ) {
      attendants.attendants_service_groups =
        jsonData.attendants_service_groups.map((item: any) =>
          AttendantServiceGroups.fromJson(item),
        );
    }

    if (
      jsonData.attendants_services &&
      Array.isArray(jsonData.attendants_services)
    ) {
      attendants.attendants_services = jsonData.attendants_services.map(
        (item: any) => AttendantServices.fromJson(item),
      );
    }

    return attendants;
  }
}
